

const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const linkResolve = require('./contentful/link-resolve');
const transformer = require('./transformers/employee');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getByDealer(dealerId, depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'employee', // eslint-disable-line,
        'sys.archivedAt[exists]': false,
        'fields.dealer.sys.id': dealerId
      }).catch(
        processError
      ).then((entries) => {
        return linkResolve(space, entries, depth).then((entries) => {
          return entries.items.map(transformer.contentfulToInternal);
        });
      });
    });
  },

  createEmpty(dealerId) {
    return {
      // published: false,
      // updated: false,
      // draft: true,

      name: '',
      department: '',
      position: '',
      phone: '',
      email: '',

      type: null,
      makesBlacklist: [],
      visibleOnWeb: false,
      hideContactInfo: false,
      importId: `custom-${Date.now()}`,
      dealerLinkId: dealerId
    };
  },

  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  save(employee, depth = 0) {
    if (!employee.id) {
      return gettingEntryService().then((service) => service.create('employee', employee, depth));
    }
    return gettingEntryService().then((service) => service.save(employee, depth));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  }
};
